import React from 'react'
import PropTypes from 'prop-types'
import Table from './table'
import { DataTable } from '@planningcenter/tapestry-react'

const RateLimitsTable = ({ rateLimits }) => {
  const columns = [
    {
      header: 'Type',
      cell: 'type',
    },
    {
      header: 'Methods',
      cell: row => row.methods.join(', '),
    },
    {
      header: 'Per-Period',
      cell: 'perPeriod',
    },
    {
      header: 'Period (Seconds)',
      cell: 'period',
    },
    {
      header: 'Details',
      cell: 'details',
    },
  ]

  const data = rateLimits.map(rl => {
    return {
      type: rl.attributes.on,
      methods: rl.attributes.methods,
      perPeriod: rl.attributes.per_period,
      period: rl.attributes.period,
      details: rl.attributes.description,
    }
  })

  return (
    <Table
      columns={columns}
      data={data}
      variant={DataTable.variants.condensed}
    />
  )
}

RateLimitsTable.propTypes = {
  rateLimits: PropTypes.array.isRequired,
}

export default RateLimitsTable
